import { CatalogoEntidades } from '@/shared/model/catalogoEntidades.model';
import { CatalogoMunicipios } from '@/shared/model/catalogoMunicipios.model';
import { InstitucionSNP } from '@/shared/model/institucionSNP.model';
import { IPersona } from '@/shared/model/persona/persona.model';
import { SedeSNP } from '@/shared/model/sedesSNP.model';
import { Acta, OpcionGraduacion, TipoBeca, Trabaja } from '@/shared/model/snp/alumno.model';

export interface IParticipante extends IPersona {
  tiempoDedicacion?: string;
  promedioAnterior?: string;
  inicioGeneracion?: string;
  inicioEstudios?: string;
  finEstudios?: string;
  fechaBaja?: string;
  motivoBaja?: string;
  reincorporacion?: string;
  acta?: Acta;
  folioActa?: string;
  opcionGraduacion?: OpcionGraduacion;
  continuarAlGradoSuperior?: boolean;
  institucion?: InstitucionSNP;
  sede?: SedeSNP;
  comprobanteEstudios?: boolean;
  comprobanteNacionalidad?: boolean;
  tieneProtocolo?: boolean;
  protocolo?: string;
  tieneImpactoCientifico?: boolean;
  impactoCientifico?: string;
  tieneImpactoSocial?: boolean;
  impactoSocial?: string;
  tieneAportacionesSolucionProblemasPrioritarios?: boolean;
  aportacionesSolucionProblemasPrioritarios?: string;
  tieneEstrategiaAccesoUniversalConocimiento?: boolean;
  estrategiaAccesoUniversalConocimiento?: string;
  trabaja?: Trabaja;
  empleadoEn?: string;
  tipoBeca?: TipoBeca;
  entidadFederativa?: CatalogoEntidades;
  municipio?: CatalogoMunicipios;
  esExtranjero?: boolean;
  numeroApoyo?: string;
}
export class Participante implements IParticipante {
  constructor(
    public cvu?: string | undefined,
    public curp?: string | undefined,
    public fechaNacimiento?: string | undefined,
    public titulo?: string | undefined,
    public nombre?: string | undefined,
    public apellidoPaterno?: string | undefined,
    public apellidoMaterno?: string | undefined,
    public rfc?: string | undefined,
    public genero?: string | undefined,
    public correo?: string | undefined,
    public login?: string | undefined,
    public gradoAcademico?: string | undefined,
    public nivelAcademico?: string | undefined,
    public nivelsni?: string | undefined,
    public paisResidencia?: string | undefined,
    public paisResidenciaCodigo?: string | undefined,
    public nacionalidad?: string | undefined,
    public nacionalidadCodigo?: string | undefined,
    public rcea?: string | undefined,
    public fotografiaUri?: string | undefined,
    public clavePrograma?: string | undefined,
    public duracionMeses?: number | undefined,
    public obtencionGrado?: string | undefined,
    public idParticipacionOrigen?: string | undefined,
    public estadoSolicitudBeca?: string,
    public tiempoDedicacion?: string | undefined,
    public promedioAnterior?: string | undefined,
    public inicioGeneracion?: string | undefined,
    public inicioEstudios?: string | undefined,
    public finEstudios?: string | undefined,
    public reincorporacion?: string | undefined,
    public fechaBaja?: string | undefined,
    public motivoBaja?: string | undefined,
    public acta?: Acta | undefined,
    public folioActa?: string | undefined,
    public opcionGraduacion?: OpcionGraduacion | undefined,
    public continuarAlGradoSuperior?: boolean | undefined,
    public institucion?: InstitucionSNP | undefined,
    public sede?: SedeSNP | undefined,
    public comprobanteEstudios?: boolean | undefined,
    public comprobanteNacionalidad?: boolean | undefined,
    public tieneProtocolo?: boolean | undefined,
    public protocolo?: string | undefined,
    public tieneImpactoCientifico?: boolean | undefined,
    public impactoCientifico?: string | undefined,
    public tieneImpactoSocial?: boolean | undefined,
    public impactoSocial?: string | undefined,
    public tieneAportacionesSolucionProblemasPrioritarios?: boolean | undefined,
    public aportacionesSolucionProblemasPrioritarios?: string | undefined,
    public tieneEstrategiaAccesoUniversalConocimiento?: boolean | undefined,
    public estrategiaAccesoUniversalConocimiento?: string | undefined,
    public trabaja?: Trabaja | undefined,
    public empleadoEn?: string | undefined,
    public tipoBeca?: TipoBeca | undefined,
    public entidadFederativa?: CatalogoEntidades | undefined,
    public municipio?: CatalogoMunicipios | undefined,
    public esExtranjero?: boolean,
    public numeroApoyo?: string | undefined
  ) {
    if (esExtranjero == undefined) {
      this.esExtranjero = false;
    }
  }

  static fromObject(item: IParticipante): Participante {
    const persona = new Participante();

    for (const [key, value] of Object.entries(item)) {
      persona[key] = value;
    }

    return persona;
  }
}
